export enum BeneficiaryStatuses {
    Draft = 'D',
    QueuedForApproval = 'Q',
    Approved = 'A',
}
